<div class="container">
  <app-header></app-header>
  @if (!isIframe && !isRestoringSession && !sessionExpired) {
    <router-outlet></router-outlet>
  }
</div>
<app-footer></app-footer>
